import { useEffect, useState } from 'react';
import { useContent } from '@hooks/use-server-content';
import HttpService from '@services/http-service/http-service';
import PreferredDealerConsentService from '@services/preferred-dealer-consent-service/preferred-dealer-consent-service';

export interface DealerConsentContent {
    modalHeaderText: string;
    modalBodyText: string;
    vehicleText: string;
    acceptButtonLabelText: string;
    acceptButtonAriaLabel: string;
    declineButtonLabelText: string;
    declineButtonAriaLabel: string;
    notificationBannerHeaderText: string;
    notificationBannerBodyText: string;
    notificationPreferredDealerErrorText?: string;
    notificationPrivacyDealerErrorText?: string;
}

export const useDealerConsentContent = (
    isAuthenticated: boolean,
    brand?: string
): DealerConsentContent | null => {
    const [content, getValueByName] = useContent(
        'common',
        'dealer-consent',
        undefined,
        undefined,
        true
    );
    const [climesBodyText, setClimesBodyText] = useState<string | null>(null);
    const isNewPreferredDealerConsentEnabled =
        process.env.REACT_APP_ENABLE_NEW_PREFERRED_DEALER_CONSENT === 'true';

    useEffect(() => {
        if (!isAuthenticated || !isNewPreferredDealerConsentEnabled) {
            return;
        }

        let isActive = true;
        const service = new PreferredDealerConsentService(HttpService);

        service.getTermsLegalLanguage(brand).then((response) => {
            if (
                !isActive ||
                !response?.legalLanguages?.length ||
                !response.legalLanguages[0].legalLanguageText
            ) {
                return;
            }

            setClimesBodyText(response.legalLanguages[0].legalLanguageText);
        });

        return () => {
            isActive = false;
        };
    }, [isAuthenticated, brand, isNewPreferredDealerConsentEnabled]);

    const contentFragment: any = {};
    if (content) {
        content?.elements.forEach((element) => {
            contentFragment[`${element.name}`] = getValueByName(
                `${element.name}`
            );
        });
    }

    if (!Object.keys(contentFragment).length) return null;

    const result = contentFragment as DealerConsentContent;

    if (climesBodyText) {
        result.modalBodyText = climesBodyText;
    }

    return result;
};
